import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormField } from '@shared/components/form/models/beans/form-field.abstract';
import { MAX_ANNO_DATA, MIN_ANNO_DATA } from '@shared/constants/shared.constants';
import { dateCoherenceValidator } from '@shared/validators/date-coherence.validator';
import { normalizeLegacyDateSeparator } from '@shared/helpers/date.helper';

@Component({
    selector: 'datefield',
    templateUrl: './datefield.component.html',
    styleUrls: ['./datefield.component.scss'],
})
export class DatefieldComponent extends FormField implements OnInit, OnDestroy {
    /** Limiti nativi del sotto-campo anno (prima linea di difesa lato browser). */
    readonly minDate = `${MIN_ANNO_DATA}-01-01`;
    readonly maxDate = `${MAX_ANNO_DATA}-12-31`;

    private valueSub: Subscription;

    ngOnInit(): void {
        const control: AbstractControl | null = this.form?.get(this.fieldName) ?? this.fieldControl ?? null;
        if (!control) {
            return;
        }
        this._normalizeLegacyValue(control);
        control.addValidators(dateCoherenceValidator);
        control.updateValueAndValidity({ emitEvent: false });
        // Ripatch da store (es. refreshFormData del FormOrchestrator) può reintrodurre il formato legacy: rinormalizza ad ogni cambio.
        this.valueSub = control.valueChanges.subscribe(() => this._normalizeLegacyValue(control));
    }

    ngOnDestroy(): void {
        this.valueSub?.unsubscribe();
    }

    private _normalizeLegacyValue(control: AbstractControl): void {
        const normalized = normalizeLegacyDateSeparator(control.value);
        if (normalized !== control.value) {
            control.setValue(normalized, { emitEvent: false });
        }
    }
}
